/*
 * @authors :Bin Mei
 * @date    :2019-05-02
 * @description： 修改页面标题
 */
import { dmEnv } from '@dm/utils';
import { setZaAppWebviewNavigationBarTitle } from './tim/open';
import Validate from './validate';

const ZALogo = require('src/images/ZALogo.png');

declare global {
  interface Window {
    upsdk: any;
  }
}

const bridge = {
  setTitle: (title: any, callBack?: Function) => {
    const defaultTitle = '众安互联网医院';
    const nextTitle = title || defaultTitle;
    if (Validate.isFromWeixin()) {
      wechatSetTitle(nextTitle);
    } else if (dmEnv.isApp() || Validate.isBestpayVideoSdk()) {
      // dmBridge.setNavigationBarTitle(nextTitle);
      setZaAppWebviewNavigationBarTitle(nextTitle);
    } else if (Validate.isFromUnionPay()) {
      window.upsdk && window.upsdk.pluginReady(function() {
        window.upsdk.setNavigationBarTitle({ title: nextTitle });
      });
    } else {
      document.title = nextTitle;
    }
  },
};

// 解决IOS在微信内不更新title的bug
function wechatSetTitle(title: string) {
  document.title = title;
  const i = document.createElement('iframe');
  // i.src = ZALogo;
  i.src = `https://online.za-doctor.com/weChatSetTitle.html`;
  i.style.display = 'none';
  i.onload = function() {
    setTimeout(function() {
      i.remove();
    }, 9);
  };
  document.body.appendChild(i);
}


/**
 * @description 获取支付宝小程序用户（openId）
 * @returns
 */
export function getAliOpenInfo(): Promise<{aliAppletOpenId; aliAppletPartnerCode}> {
  if (typeof my === 'undefined') {
    return Promise.resolve({} as any);
  }
  // 发送通知
  my.postMessage({ action: 'ALIPAY_APPLET_GET_BASE_INFO' });

  // 再快，他也是异步啊
  return new Promise((resolve) => {
    // 接收通知
    my.onMessage = (message: any) => {
      console.log('onMessage', message);
      if (!message) {
        return;
      }
      const { action, data } = message;
      switch (action) {
      case 'ALIPAY_APPLET_GET_BASE_INFO':
        // eslint-disable-next-line no-case-declarations
        const { aliAppletOpenId, aliAppletPartnerCode } = data || {};
        resolve({ aliAppletOpenId, aliAppletPartnerCode });
        break;

      case 'ALIPAY_APPLET_REFRESH_PAGE':
        window.location.reload();
        break;
      default:
        console.log('未处理的action！');
        resolve({} as any);
        break;
      }
    };
  });
}

/**
 * @description 通知支付宝小程序更新缓存中 isRealAuth 的值
 * @param value 值
 */
export function updateIsRealAuth(value: string) {
  if (typeof my === 'undefined') {
    return;
  }
  my.postMessage({ action: 'ALIPAY_APPLET_UPDATE_IS_REAL_AUTH', data: { value } });
}

export default bridge;
